import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { jsx as _jsx } from "react/jsx-runtime";
const KEYS_TO_KEEP = ['search', 'queryType', 'sort'];
export function ClearFiltersButton() {
  const params = useSearchParams();
  const handleClick = () => {
    params.keys().forEach(key => {
      if (!KEYS_TO_KEEP.includes(key)) params.delete(key);
    });
  };
  return (
    /*#__PURE__*/
    // wrapping in a div to prevent unwanted expansion
    _jsx("div", {
      children: /*#__PURE__*/_jsx(Button, {
        use: "link",
        onClick: handleClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceStorefront.filters.clearAll"
        })
      })
    })
  );
}